export const hasAnyVariantZeroCost = (variants) => {
    return variants.some((variant) => variant.cost?.value === 0);
};
